import { RootState } from '@services/store/type'

export const getIsSearchHeaderOpen = (state: RootState) =>
	state.articles.isSearchHeaderOpen
export const getSearchText = (state: RootState) => state.articles.searchText
export const getIsPageArticles = (state: RootState) =>
	state.articles.isPageArticles
export const getSearchResults = (state: RootState) =>
	state.articles.searchResults
